var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.$style.titleWrapper
  }, [_setup.editEnabled ? _c(_setup.SInput, {
    directives: [{
      name: "ym-disable-keys",
      rawName: "v-ym-disable-keys"
    }],
    class: _vm.$style.inputTitle,
    attrs: {
      "size": "small"
    },
    on: {
      "enter": _setup.handlerChangeTitle,
      "blur": _setup.handlerChangeTitle
    },
    model: {
      value: _setup.collectionTitle,
      callback: function callback($$v) {
        _setup.collectionTitle = $$v;
      },
      expression: "collectionTitle"
    }
  }) : [_c('AppTitle', {
    class: _vm.$style.title,
    attrs: {
      "semantic-head-level": "1",
      "style-head-level": "1"
    }
  }, [_vm._v("\n      " + _vm._s(_setup.collectionTitle) + "\n    ")]), _vm._v(" "), _c(_setup.SIcon, {
    class: _vm.$style.editIcon,
    attrs: {
      "icon": "i-pencil-line",
      "size": "24"
    },
    nativeOn: {
      "click": function click($event) {
        return _setup.handlerEditedTitle.apply(null, arguments);
      }
    }
  })]], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };